import {
  FacebookLogoMonoLightIcon,
  InstagramLogoMonoLightIcon,
  SpotifyMonoLightIcon,
  TiktokLogoMonoLightIcon,
  XLightIcon,
  YoutubeLogoMonoLightIcon,
} from "@stubhub/broadway-web/icons/brands";
import {
  SOCIAL_MEDIA_ID_FACEBOOK,
  SOCIAL_MEDIA_ID_INSTAGRAM,
  SOCIAL_MEDIA_ID_SPOTIFY,
  SOCIAL_MEDIA_ID_TIKTOK,
  SOCIAL_MEDIA_ID_TWITTER,
  SOCIAL_MEDIA_ID_X,
  SOCIAL_MEDIA_ID_YOUTUBE,
} from "src/website-apps/shared/constants/social-links";

export const PLATFORM_ICON_MAP = {
  [SOCIAL_MEDIA_ID_TWITTER]: XLightIcon,
  [SOCIAL_MEDIA_ID_X]: XLightIcon,
  [SOCIAL_MEDIA_ID_INSTAGRAM]: InstagramLogoMonoLightIcon,
  [SOCIAL_MEDIA_ID_FACEBOOK]: FacebookLogoMonoLightIcon,
  [SOCIAL_MEDIA_ID_SPOTIFY]: SpotifyMonoLightIcon,
  [SOCIAL_MEDIA_ID_YOUTUBE]: YoutubeLogoMonoLightIcon,
  [SOCIAL_MEDIA_ID_TIKTOK]: TiktokLogoMonoLightIcon,
};
